<main  class="container" [ngClass]="snav.opened ? 'backdrop' : ''">
  <mat-toolbar class="header" color="primary" [ngClass]="snav.opened ? 'backdrop' : ''">
    <button mat-icon-button matTooltip="Menu" (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <a [routerLink]="'/home'" style="text-decoration: none; color: white;"><span>{{ title }}</span></a>
    <span class="toolbar-item-spacer"></span>

    <ng-container *ngIf='currentUser.isLoggedIn | async'>
      <button mat-icon-button matTooltip="My Account" [matMenuTriggerFor]="accountMenu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #accountMenu [overlapTrigger]="false" yPosition="below">
        <button mat-menu-item class="disable-click">
          <mat-icon style="color: #b5121b;">person</mat-icon><span>{{currentUser.name | async}}</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logOutButton($event)">
          <mat-icon style="color: #b5121b;">logout</mat-icon>Log out
        </button>
      </mat-menu>
    </ng-container>

    <ng-container *ngIf='isAuthenticating === false'>
      <button *ngIf='(currentUser.isLoggedIn | async) === false' mat-button (click)="logInButton($event)">
        <mat-icon>login</mat-icon><span>Log in</span>
      </button>
    </ng-container>
  </mat-toolbar>  
  <mat-sidenav-container autosize color="primary">
    <mat-sidenav #snav mode="over">
      <mat-toolbar class="header" color="primary">
        <button mat-icon-button matTooltip="Menu" (click)="snav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <!-- <span>PBA</span> -->
        <a [routerLink]="'/home'"  style="text-decoration: none; color: white;">PerformPBI</a>
        <span class="toolbar-item-spacer"></span>
      </mat-toolbar>
      <mat-nav-list>
        <!-- <a mat-list-item [routerLink]="'/home'" (click)="snav.close()">
            <mat-icon style="color:#0082ca;">house</mat-icon>
             <span style="display: table-caption; padding-left: 5px;">Report</span>
        </a> -->
        <!-- <mat-list-item *ngFor="let item of menuItems" (click)="navigate(item.url); snav.toggle()">
          <mat-icon style="color:#0082ca; vertical-align: middle;"> {{item.icon}} </mat-icon><span style="vertical-align: middle;"> {{item.label}} </span>
        </mat-list-item> -->
      </mat-nav-list>
      <mat-nav-list *ngIf="isExists === false">
        <h2>No access to tableau reports</h2>
      </mat-nav-list>
      <mat-nav-list *ngIf="isExists === true">
          <!-- <a mat-list-item (click)="navigate(menuItems[3].url); snav.toggle()">
              <mat-icon style="color:#b5121b;">house</mat-icon>
              <span style="display: table-caption; padding-left: 5px;">VN_RLS_Test</span>
          </a>
          <a mat-list-item (click)="navigate(menuItems[4].url); snav.toggle()">
            <mat-icon style="color:#b5121b;">house</mat-icon>
            <span style="display: table-caption; padding-left: 5px;">Drug Details Test</span>
          </a> -->
          <a mat-list-item #dashboardMenu="matMenuTrigger" [matMenuTriggerFor]="custDashboard">
              <mat-icon style="color:#b5121b; vertical-align: middle; padding-right: 3px;">dashboard</mat-icon>
              <span style="vertical-align: middle;">Customer Dashboards</span>
             
              <mat-icon *ngIf="!dashboardMenu.menuOpen" style="color:#b5121b; vertical-align: middle; padding-left: 8px;">keyboard_arrow_down</mat-icon>
              <mat-icon *ngIf="dashboardMenu.menuOpen" style="color:#b5121b; vertical-align: middle; padding-left: 8px;">keyboard_arrow_up</mat-icon>
          </a>
          <a mat-list-item #referenceMenu="matMenuTrigger" [matMenuTriggerFor]="custReference">
            <mat-icon style="color:#b5121b; vertical-align: middle;  padding-right: 3px;">find_in_page</mat-icon>
            <span style="vertical-align: middle;">Customer References</span>
            <mat-icon *ngIf="!referenceMenu.menuOpen" style="color:#b5121b; vertical-align: middle; padding-left: 8px;">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="referenceMenu.menuOpen" style="color:#b5121b; vertical-align: middle; padding-left: 8px;">keyboard_arrow_up</mat-icon>
          </a>

        
          <mat-menu #custDashboard="matMenu" xPosition="after">
            <button mat-menu-item [matMenuTriggerFor]="Performance">Performance Metrics Review</button>
            <button mat-menu-item [matMenuTriggerFor]="Therapeutic">Therapeutic Class Review</button>
            <button mat-menu-item [matMenuTriggerFor]="Drug">Drug Utilization Review</button>
            <button mat-menu-item [matMenuTriggerFor]="Member">Member Profile</button>
            <button mat-menu-item [matMenuTriggerFor]="Provider">Provider Profile</button>
            <button mat-menu-item [matMenuTriggerFor]="Clinical">Clinical Module</button>
          </mat-menu>
          <mat-menu #Performance="matMenu">
            <button mat-menu-item (click)="navigate(menuItems[0].url); snav.toggle()">KPI Summary</button>
          </mat-menu>
          <mat-menu #Therapeutic="matMenu">
            <button mat-menu-item (click)="navigate(menuItems[1].url); snav.toggle()">Top N Therapy Class and Drug Details</button>
            <button mat-menu-item (click)="navigate(menuItems[2].url); snav.toggle()">Top N Therapy Class Market Share</button>
          </mat-menu>
          <mat-menu #Drug="matMenu">
            <button mat-menu-item (click)="navigate(menuItems[3].url); snav.toggle()">Drugs By Product Type</button>
            <button mat-menu-item (click)="navigate(menuItems[4].url); snav.toggle()">Trend</button>
            <button mat-menu-item (click)="navigate(menuItems[5].url); snav.toggle()">Ranking by Paid Amount</button>
            <button mat-menu-item (click)="navigate(menuItems[6].url); snav.toggle()">Quantity Per Prescription</button>
            <button mat-menu-item (click)="navigate(menuItems[7].url); snav.toggle()">Search by Claim Number</button>
          </mat-menu>
          <mat-menu #Member="matMenu">
            <button mat-menu-item (click)="navigate(menuItems[8].url); snav.toggle()">Member Profile</button>
            <button mat-menu-item (click)="navigate(menuItems[9].url); snav.toggle()">Member Drug Utilization Review</button>
            <button mat-menu-item (click)="navigate(menuItems[10].url); snav.toggle()">Member Compliance</button>
          </mat-menu>
          <mat-menu #Provider="matMenu">
            <button mat-menu-item (click)="navigate(menuItems[11].url); snav.toggle()">Search by Pharmacy</button>
            <button mat-menu-item (click)="navigate(menuItems[12].url); snav.toggle()">Top N Pharmacy Profile</button>
            <button mat-menu-item (click)="navigate(menuItems[13].url); snav.toggle()">Pharmacy Network by Affiliation</button>
            <button mat-menu-item (click)="navigate(menuItems[14].url); snav.toggle()">Search by Prescriber</button>
            <button mat-menu-item (click)="navigate(menuItems[15].url); snav.toggle()">Prescriber Profile</button>
            <button mat-menu-item (click)="navigate(menuItems[16].url); snav.toggle()">Top N By Selected Dimension</button>
          </mat-menu>
          <mat-menu #Clinical="matMenu">
            <button mat-menu-item (click)="navigate(menuItems[17].url); snav.toggle()">Min Max Dosage Data Driven</button>
            <button mat-menu-item (click)="navigate(menuItems[18].url); snav.toggle()">Duplicate Therapy Data Driven</button>
          </mat-menu>
          

         
          <mat-menu #custReference="matMenu">
            <button mat-menu-item (click)="navigate(menuItems[19].url); snav.toggle()">Drug Information & Price</button>
            <button mat-menu-item (click)="navigate(menuItems[20].url); snav.toggle()">AWP_WAC_NADAC_PRICE</button>
            <button mat-menu-item (click)="navigate(menuItems[21].url); snav.toggle()">Speciality</button>
            <button mat-menu-item (click)="navigate(menuItems[22].url); snav.toggle()">PRx Network Map</button>
            <button mat-menu-item (click)="navigate(menuItems[23].url); snav.toggle()">Min Max Dosage Reference</button>
            <button mat-menu-item (click)="navigate(menuItems[24].url); snav.toggle()">Duplicate Therapy Reference</button>
            <button mat-menu-item (click)="navigate(menuItems[25].url); snav.toggle()">Drug Interaction Message</button>
          </mat-menu>
      </mat-nav-list>
    </mat-sidenav>
   
    <!-- <mat-sidenav-content> -->
      <router-outlet></router-outlet>
    <!-- </mat-sidenav-content> -->
  </mat-sidenav-container>
 
  
  <ng-container *ngIf="isAuthenticating">
    <p id="loading-spinner-text">Loading...</p>
    <mat-spinner id="loading-spinner"></mat-spinner>
  </ng-container>
</main>
<footer class="footer" [ngClass]="snav.opened ? 'backdrop' : ''">
  <mat-divider class="divider"></mat-divider>
  <p class="footer-text">Copyright © {{currentYear}} AmeriHealth Caritas. All rights reserved</p>
</footer>